import { Sparkles } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { NoraWidget } from '../NoraWidget'
import { NoraFloatingButtonProps } from './NoraFloatingButton.props'
import * as S from './styles'

export function NoraFloatingButton ({ isOpen: controlledIsOpen, onToggle, buttonContent, buttonStyle, initialPrompt }: NoraFloatingButtonProps): React.ReactElement {
  const [internalIsOpen, setInternalIsOpen] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen

  const toggleDrawer = (): void => {
    if (isAnimating) return

    setIsAnimating(true)
    const newIsOpen = !isOpen

    if (onToggle) {
      onToggle(newIsOpen)
    } else {
      if (!isOpen) {
        setInternalIsOpen(true)
      } else {
        setTimeout(() => {
          setInternalIsOpen(false)
        }, 400)
      }
    }
  }

  useEffect(() => {
    if (isAnimating) {
      const timer = setTimeout(() => {
        setIsAnimating(false)
      }, 500)
      return () => clearTimeout(timer)
    }
  }, [isAnimating])
  const defaultButtonContent = <Sparkles size={24} color="white" />

  return (
    <>
      {!isOpen && controlledIsOpen === undefined && <S.FloatingButton
        onClick={toggleDrawer}
        className={isAnimating ? 'animating' : ''}
        style={buttonStyle}
      >
        {buttonContent ?? defaultButtonContent}
      </S.FloatingButton>}

      {isOpen && <>
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 9999,
            backdropFilter: 'blur(12px)',
            transition: 'opacity 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
          }}
          onClick={toggleDrawer}
        />
        <div
          style={{
            position: 'fixed',
            width: '90%',
            maxWidth: '900px',
            height: 'calc(90vh - 30px)',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%) scale(1)',
            borderRadius: '20px',
            boxShadow: '0 25px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1)',
            overflow: 'hidden',
            zIndex: 10001,
            backgroundColor: 'rgba(245, 245, 247, 0.95)',
            backdropFilter: 'blur(20px)',
            transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
          }}
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
        >
          <div style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            zIndex: 10002
          }}>
            <button
              onClick={toggleDrawer}
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                color: 'white',
                border: 'none',
                fontSize: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}
            >
              ×
            </button>
          </div>
          <NoraWidget initialPrompt={initialPrompt} />
        </div>
      </>}
    </>
  )
};

export default NoraFloatingButton
